export const MARKETS_UPDATE = "markets_update";
export const ORDER_BOOK_UPDATE = "ORDER_BOOK_UPDATE";
export const INITIALIZE_SOCKET_MESSAGES = "initialize_socket_messages";
